import React from 'react';
import List from '../../components/list/List';
import { LegendProps } from '../mapContent/api/Contracts';
import LegendItem, { LegendItemProps } from './LegendItem';

interface LegendListProps {
  legend: LegendProps[];
  title?: string;
  isRoot?: boolean;
  showCommands?: boolean;
  downloadUrl?: string | undefined;
  metadataUrl?: string | undefined;
}

const LegendTitle = ({ title }: { title?: string }) => (
  <div className="legend-list__item-title" title={title}>
    {title}
  </div>
);

const LegendSymbols = ({
  legend,
  title,
  isRoot,
  showCommands,
  downloadUrl,
  metadataUrl,
}: LegendListProps) => {
  if (!legend) {
    return <LegendTitle title={title} />;
  }

  const isOnlyOneItem = legend.length === 1 && legend[0].label.length === 0;

  const renderLegendItem = (item: LegendItemProps) => (
    <LegendItem
      {...item}
      label={item.label?.trim() || title || ''}
      showCommands={showCommands}
      metadataUrl={metadataUrl}
      downloadUrl={downloadUrl}
    />
  );

  if ((isRoot && isOnlyOneItem) || isOnlyOneItem)
    return renderLegendItem({
      contentType: legend[0].contentType,
      imageData: legend[0].imageData,
      image: legend[0].image,
      label: legend[0].label,
      showCommands,
      metadataUrl,
      downloadUrl,
    });

  return (
    <>
      {!isOnlyOneItem && title && <LegendTitle title={title!} />}

      <List
        ulClassName="legend-list"
        liClassName="legend-list__item"
        items={legend.map((item) => ({
          contentType: item.contentType,
          imageData: item.imageData,
          image: item.image,
          label: item.label,
          showCommands,
          metadataUrl,
          downloadUrl,
          id: item.label,
        }))}
        renderItem={renderLegendItem}
      />
    </>
  );
};

export default LegendSymbols;
